// Square configuration helper
// This file centralizes Square credentials management

const getSquareConfig = () => {
    // Environment detection (including fallback to window.env if available)
    const windowEnv = typeof window !== 'undefined' ? window.env || {} : {};
    const isProduction = process.env.NODE_ENV === 'production';
    
    // Get Square credentials with fallbacks
    // 1. Try window.env first (for runtime injection in production)
    // 2. Then try process.env (for build-time injection)
    // 3. Finally fallback to hardcoded values as absolute last resort
    
    // For production
    const squareProductionAppId = 
      windowEnv.REACT_APP_SQUARE_PRODUCTION_APP_ID || 
      process.env.REACT_APP_SQUARE_PRODUCTION_APP_ID || 
      'sq0idp-bljobGRCZjY7janv4oqJAg'; // Fallback value from .env
      
    const squareProductionLocationId = 
      windowEnv.REACT_APP_SQUARE_PRODUCTION_LOCATION_ID || 
      process.env.REACT_APP_SQUARE_PRODUCTION_LOCATION_ID || 
      '8HM1V8JWPG3TX'; // Fallback value from .env
    
    // For sandbox/development
    const squareSandboxAppId = 
      windowEnv.REACT_APP_SQUARE_APP_ID || 
      process.env.REACT_APP_SQUARE_APP_ID || 
      'sandbox-sq0idb-EQzA66maEj43JXD0aQXwRg'; // Fallback value from .env
      
    const squareSandboxLocationId = 
      windowEnv.REACT_APP_SQUARE_LOCATION_ID || 
      process.env.REACT_APP_SQUARE_LOCATION_ID || 
      'LSEJAPDJT6G9V'; // Fallback value from .env
    
    // Get the appropriate credentials based on environment
    const squareAppId = isProduction ? squareProductionAppId : squareSandboxAppId;
    const squareLocationId = isProduction ? squareProductionLocationId : squareSandboxLocationId;
    
    // Log availability for debugging (only in development)
    if (process.env.NODE_ENV !== 'production') {
      console.log('Square configuration:', {
        environment: isProduction ? 'PRODUCTION' : 'SANDBOX',
        appIdExists: !!squareAppId,
        locationIdExists: !!squareLocationId,
        usingFallbacks: !process.env.REACT_APP_SQUARE_PRODUCTION_APP_ID || !process.env.REACT_APP_SQUARE_PRODUCTION_LOCATION_ID
      });
    }
    
    return {
      isProduction,
      squareAppId,
      squareLocationId
    };
  };
  
  export default getSquareConfig;